import { createIcon, Svg } from "@gluestack-ui/icon";
import { Path } from "react-native-svg";

const CupIntake1 = createIcon({
  Root: Svg,
  viewBox: "0 0 48 62",
  path: (
    <>
      <Path
        d="M10.7859 60.3083C9.05207 60.3083 7.60406 58.9868 7.446 57.2602L2.69391 5.35101C2.51404 3.38621 4.06078 1.69141 6.03379 1.69141H41.9339C43.9152 1.69141 45.4647 3.3999 45.2718 5.37183L40.193 57.281C40.025 58.9986 38.5809 60.3083 36.8551 60.3083H10.7859Z"
        fill="white"
        stroke="#4767CA"
        strokeWidth="2.5"
        strokeMiterlimit="10"
      />
      <Path
        d="M41.3474 45.4877C41.3474 45.4877 35.2434 53.0171 25.2657 47.1897C15.288 41.3624 8.84026 41.505 6.01465 45.0014L7.71673 60.3117H39.8969L41.3474 45.4877Z"
        fill="#A0DDF9"
      />
      <Path
        d="M10.7859 60.3083C9.05207 60.3083 7.60406 58.9868 7.446 57.2602L2.69391 5.35101C2.51404 3.38621 4.06078 1.69141 6.03379 1.69141H41.9339C43.9152 1.69141 45.4647 3.3999 45.2718 5.37183L40.193 57.281C40.025 58.9986 38.5809 60.3083 36.8551 60.3083H10.7859Z"
        stroke="#4767CA"
        strokeWidth="2.5"
        strokeMiterlimit="10"
      />
    </>
  ),
});

export { CupIntake1 };
